var render = function render(){var _vm=this,_c=_vm._self._c;return _c('t-tag',{attrs:{"type":_vm.type,"soft":""}},[_vm._v("\n  "+_vm._s(_vm.label)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }